export default "__VITE_ASSET__Df3SShd6__"